export default __webpack_public_path__ + "img/dfe374f73d50d9ee688422b2df3c21b7.svg";